import { useLanguage } from '@/i18n/LanguageContext';
import marketTrionfale from '@/assets/market-trionfale.jpg';
import vaticanHome from '@/assets/vatican-baldaquino-home.webp';
import trastevereNight from '@/assets/trastevere-night.webp';
import { motion } from 'framer-motion';
import { Landmark, UtensilsCrossed, MapPin, Church, Moon, ShoppingBag, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ExperiencesSection = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const experiences = [
  { id: 'colosseum', icon: Landmark, title: t.experiences.colosseum, desc: t.experiences.colosseumDesc, img: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=450&q=75&fm=webp' },
  { id: 'cuisine', icon: UtensilsCrossed, title: t.experiences.cuisine, desc: t.experiences.cuisineDesc, img: 'https://images.unsplash.com/photo-1498579150354-977475b7ea0b?w=450&q=75&fm=webp' },
  { id: 'piazzas', icon: MapPin, title: t.experiences.piazzas, desc: t.experiences.piazzasDesc, img: 'https://images.unsplash.com/photo-1531572753322-ad063cecc140?w=450&q=75&fm=webp' },
  { id: 'vatican', icon: Church, title: t.experiences.vatican, desc: t.experiences.vaticanDesc, img: vaticanHome },
  { id: 'trastevere', icon: Moon, title: t.experiences.trastevere, desc: t.experiences.trastevereDesc, img: trastevereNight },
  { id: 'markets', icon: ShoppingBag, title: t.experiences.markets, desc: t.experiences.marketsDesc, img: marketTrionfale }];


  return (
    <section id="experiences" className="relative bg-secondary/30 py-24 md:py-32">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16 text-center">

          <p className="font-serif-elegant uppercase tracking-[0.3em] text-primary/70 text-base font-bold">
            La Dolce Vita
          </p>
          <h2 className="mt-3 font-serif text-3xl tracking-wide text-foreground md:text-5xl">
            {t.experiences.title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-muted-foreground">
            {t.experiences.subtitle}
          </p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {experiences.map((exp, i) =>
          <motion.div
            key={exp.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="glass-card group overflow-hidden rounded-lg">

              <div className="relative h-48 overflow-hidden">
                <img
                src={exp.img}
                alt={exp.title}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy" />

                <div className="absolute inset-0 bg-gradient-to-t from-background/90 to-transparent" />
                <exp.icon className="absolute bottom-4 left-4 h-6 w-6 text-primary" />
              </div>
              <div className="p-5">
                <h3 className="font-serif text-lg tracking-wide text-foreground">{exp.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{exp.desc}</p>
                <button
                  onClick={() => navigate(`/experience/${exp.id}`)}
                  className="mt-3 inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-primary transition-colors hover:text-primary/70 font-semibold"
                >
                  {t.experiences.moreInfoBtn}
                  <ArrowRight className="h-3.5 w-3.5" />
                </button>
              </div>
            </motion.div>
          )}
        </div>
      </div>
    </section>);

};

export default ExperiencesSection;